import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const REFERRALS = `${PRIVATE_ROOT}/community/referrals`
export const REFER_A_FREIND = `${PRIVATE_ROOT}/community/referrals/refer-a-friend`
